exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ha-t {\r\n    font-size: 1.6rem;\r\n    margin: 0px;\r\n    padding: 0px;\r\n    font-weight: 500;\r\n    text-align: center;\r\n    margin-bottom: 16px;\r\n}", ""]);

// exports
